/*=========================================================================================
  File Name: moduleCalendar.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './modulePlannerState.js'
import mutations from './modulePlannerMutations.js'
import actions from './modulePlannerActions.js'
import getters from './modulePlannerGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
